import { Permission } from '~/enums'

export const PAYOUT_ACCOUNT_PERMISSIONS: readonly Permission[] = [
  Permission.VIEW_PAYOUT_ACCOUNT,
  Permission.CREATE_PAYOUT_ACCOUNTS,
  Permission.EDIT_PAYOUT_ACCOUNTS
]
